import { FC } from 'react'
import { Box, Typography, Grid, Paper, Card, CardContent } from '@mui/material'
import {
  People as PeopleIcon,
  Work as WorkIcon,
  Inventory as InventoryIcon,
} from '@mui/icons-material'
import {
  useGetClientsQuery,
  useGetProjectsQuery,
  useGetInventoryItemsQuery,
} from '../../redux/hooks.ts'

export const Dashboard: FC = () => {
  const clientsQuery = useGetClientsQuery()
  const projectsQuery = useGetProjectsQuery()
  const inventoryItemsQuery = useGetInventoryItemsQuery()

  const stats = [
    {
      title: 'Total Clients',
      value: clientsQuery.data?.length || 0,
      icon: PeopleIcon,
      color: '#1976d2',
    },
    {
      title: 'Total Projects',
      value: projectsQuery.data?.length || 0,
      icon: WorkIcon,
      color: '#388e3c',
    },
    {
      title: 'Total Items',
      value: inventoryItemsQuery.data?.length || 0,
      icon: InventoryIcon,
      color: '#f57c00',
    },
  ]

  return (
    <Box>
      <Typography variant="h6" gutterBottom color="text.secondary">
        Welcome to your dashboard
      </Typography>

      <Grid container spacing={3} sx={{ marginTop: 2 }}>
        {stats.map((stat) => {
          const Icon = stat.icon
          return (
            <Grid component="div" size={{ xs: 12, sm: 6, md: 4 }} key={stat.title}>
              <Card elevation={2}>
                <CardContent>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box>
                      <Typography color="text.secondary" gutterBottom variant="body2">
                        {stat.title}
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold">
                        {stat.value}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: stat.color,
                        borderRadius: '50%',
                        padding: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Icon sx={{ color: 'white', fontSize: 32 }} />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )
        })}
      </Grid>

      <Grid container spacing={3} sx={{ marginTop: 3 }}>
        <Grid component="div" size={{ xs: 12 }}>
          <Paper elevation={2} sx={{ padding: 3 }}>
            <Typography variant="h6" gutterBottom>
              Recent Activity
            </Typography>
            <Typography color="text.secondary">No recent activity to display.</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  )
}
